import {
  Box,
  IconButton,
  Stack,
  Typography,
  keyframes,
  styled,
} from '@mui/material';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledBundleContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.grey[800],
  [theme.breakpoints.down('md')]: {},
}));

export const StyledBundleHead = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(3),
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'start',
  },
}));

export const StyledBundleInfo = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  flex: 1,
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
}));

export const StyledBundleTitle = styled(Typography)({
  fontSize: 'clamp(16px, 1.3vw, 24px)',
  fontFamily: fontFamily.drukWideMedium,
  fontWeight: 500,
});

export const StyledBundleActions = styled(Stack)(({ theme }) => ({
  alignItems: 'start',
  height: theme.spacing(5),
}));

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const StyledBundleActionButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.75),
  height: '100%',
  aspectRatio: '1 / 1',
  svg: {
    height: '100%',
    width: 'auto',
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[700],
  },
  animationName: fadeIn,
  animationDuration: '1s',
}));

export const StyledBundleActionSkeleton = styled(Box)(({ theme }) => ({
  height: '100%',
  width: 'auto',
  aspectRatio: '1 / 1',
  background: theme.palette.grey[700],
  borderRadius: '50%',
}));
